import { render, staticRenderFns } from "./projectSetTotalScoringForm.vue?vue&type=template&id=52da1f1e&scoped=true&"
import script from "./projectSetTotalScoringForm.vue?vue&type=script&lang=js&"
export * from "./projectSetTotalScoringForm.vue?vue&type=script&lang=js&"
import style0 from "./projectSetTotalScoringForm.vue?vue&type=style&index=0&id=52da1f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da1f1e",
  null
  
)

export default component.exports